const binding = { modules: {}, dataActions: {} };

    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    

    (binding.modules['webgroup-search-container'] = {
        c: () => require('partner/modules/webgroup-search-container/webgroup-search-container.tsx'),
        $type: 'containerModule',
        da: [{name:'categories',  path:'actions/get-categories-hierarchy-with-root.action', runOn: 0},{name:'filters',  path:'actions/get-webgroup-filters', runOn: 0},{name:'webGroupSearchResult',  path:'actions/get-webgroup-search-results', runOn: 0},{name:'webgroups',  path:'actions/get-webgroup-by-category', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'webgroup-search-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/webgroup-search-container'
    });
        

        {
            const sanitizedActionPath = 'actions/get-categories-hierarchy-with-root.action';
            let dataAction = require('partner/actions/get-categories-hierarchy-with-root.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'actions/get-webgroup-by-category';
            let dataAction = require('partner/actions/get-webgroup-by-category');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'actions/get-webgroup-filters';
            let dataAction = require('partner/actions/get-webgroup-filters');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'actions/get-webgroup-search-results';
            let dataAction = require('partner/actions/get-webgroup-search-results');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|webgroup-search-container|webgroup-search-container'] = {
                c: () => require('partner/modules/webgroup-search-container/webgroup-search-container.view.tsx'),
                cn: '__local__-__local__-webgroup-search-container'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };